import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from 'react-select'

import { Link, useHistory, useParams } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import  * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Timeline from './Timeline';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

    const ApproveIPA = () => {
        const {no} = useParams();
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [apType , setApType] = useState(['Annual', 'Probation'])

        const [btnprimary1, setBtnprimary1] = useState(false)
        const [rows1, setrows1] = useState([{ id: 1 }]);
        const [th, setTh] = useState(['Customer','Financial','Internal Business Process','Learning and Growth'])
        const [periods , setPeriods] = useState(['January-June', 'July-December'])
        const [inputs, setInputs] = useState([]);

        const [empNo, setEmpNo] = useState('')
        const [empName, setEmpName] = useState('')
        const [empTitle, setEmpTitle] = useState('')

        const [supervisorNo, setSupervisorNo] = useState('')
        const [supervisorName, setSupervisorName] = useState('')
        const [supervisorTitle, setSupervisorTitle] = useState('')

        const [ipaLines1, setIpaLines1] = useState([])
        const [ipaLines2, setIpaLines2] = useState([])
        const [ipaLines3, setIpaLines3] = useState([])
        const [ipaLines4, setIpaLines4] = useState([])

        const [startDate, setStartDate] = useState(new Date());
        const [endDate, setEndDate] = useState(new Date());
        const [type, setType] = useState('');

        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaNo, setIpaNo] = useState('')
        const [ipaStatus, setIpaStatus] = useState('')
        const [ipaDate, setIpaDate] = useState('')
        const [ipaPerformanceYear, setIpaPerformanceYear] = useState('')
        const [ipaConvert, setIpaConvert] = useState('')
        const [appraisalPeriod, setAppraisalPeriod] = useState('')
        const [documentType, setDocumentType] = useState('')
        const [performanceType, setPerformanceType] = useState('')
        const [departmentCode, setDepartmentCode] = useState('')
        const [stage, setStage] = useState('')
        const [lines, setLines] = useState([])
        const [st, setSt] = useState(0)
        const [CompanyID, setCompanyID] = useState("")

        const [showApproveBtn, setShowApproveBtn] = useState(true);
        const [showRejectBtn, setShowRejectBtn] = useState(false);
        const [comment, setComment] = useState('')
        

        const fetchData = () => {
            let obj = JSON.parse(localStorage.getItem("authMildUser"));
            setCompanyID(obj.activeCompany);
            setIsloading(true)
            axios.get(`${url.IPAS_X}?$filter=No eq '${no}'&$expand=ipaLines,ipaLines2,ipaLines3,ipaLines4&company='${obj.activeCompany}'`, HRConfig)
                .then(function(response){                  
                    axios.get(`${url.EMPLOYEES}?$filter=No eq '${response.data.value[0].EmployeeNo}'&company='${obj.activeCompany}'`, HRConfig).then((r)=>{ 
                        setEmpName(r.data.value[0].FirstName +" "+r.data.value[0].LastName)
                        setEmpTitle(r.data.value[0].JobTitle)
                    }).catch((e)=>{ console.log(e) })
                    axios.get(`${url.EMPLOYEES}?$filter=No eq '${response.data.value[0].Appraiser}'&company='${obj.activeCompany}'`, HRConfig).then((r)=>{ 
                        setSupervisorName(r.data.value[0].FirstName +" "+r.data.value[0].LastName)
                        setSupervisorTitle(r.data.value[0].JobTitle)
                    }).catch((e)=>{ console.log(e) })
                    setEmpNo(response.data.value[0].EmployeeNo)
                    
                    setSupervisorNo(response.data.value[0].Appraiser)
                    setDepartmentCode(response.data.value[0].DepartmentCode)
                    setIpaDate(response.data.value[0].PostingDate)
                    setIpaPerformanceYear(response.data.value[0].PerformanceYear)
                    setIpaStatus(response.data.value[0].Status)
                    setIpaConvert(response.data.value[0].ConvertToAppraisal)
                    setAppraisalPeriod(response.data.value[0].AppraisalPeriod)
                    setIpaNo(response.data.value[0].No)
                    setDocumentType(response.data.value[0].DocumentType)
                    setPerformanceType(response.data.value[0].PerformanceType)
                    setStage(response.data.value[0].Stage)
                    setStartDate(response.data.value[0].FromDate)
                    setEndDate(response.data.value[0].ToDate)
                    setType(response.data.value[0].TypeofPerformanceAppraisal)
                    setIpaLines1(response.data.value[0].ipaLines)
                    setIpaLines2(response.data.value[0].ipaLines2)
                    setIpaLines3(response.data.value[0].ipaLines3)
                    setIpaLines4(response.data.value[0].ipaLines4)
                    if(response.data.value[0].Status == 'Open'){
                        setSt(0);
                    }else if(response.data.value[0].Status == 'Pending Approval'){
                        setSt(1);
                    }
                    setIsloading(false)
                }).catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setUserError(true);
                    setIsloading(false)
            })
        }
        useEffect(() => {
           fetchData();
        },[]);

        const handleRejectIpa = () =>{
            setIsloading(true)
            const lNo = {"no": ipaNo, "rejectioncomment":comment}
            axios.post(url.REJECT_LR+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){ 
                    if(response.status == '200'){
                        toastr.success("IPA approval rejected");
                        history.push(`/rejected/${ipaNo}`) 
                    }else{
                        toastr.success("Could not Approve midterm review" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    console.log(error)
                    setIsloading(false)
            })  
        }

        const handleApproveIpa = () =>{
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(url.APPROVENFLREQUEST +'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success("IPA Approved" );
                        history.push(`/approved/${ipaNo}`) 
                    }else{
                        toastr.success("Could not Approve IPA" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setIsloading(false)
                })
        }

        const handleActionChange = () =>{
            const selectedAction = document.getElementsByClassName('lAction')[0].value;
            if(selectedAction == 'APPROVE'){
                setShowApproveBtn(true)
                setShowRejectBtn(false)
            }else if(selectedAction == 'REJECT'){
                setShowApproveBtn(false)
                setShowRejectBtn(true)
            }
        }

        return (
            <LoadingOverlay
            active={isloading}
            spinner={<BounceLoader />}
            text='Please wait...'
            >
            <div className="page-content">
            <MetaTags>
            <title>Approve IPA | Bridge</title>
            </MetaTags>
            <Container fluid={true}>
                <Breadcrumbs title="Human Resource Management" breadcrumbItem="Approve Individual Performance Agreement" />
                <div>
                <Row>                
                    <Alert color='danger' role="alert">
                        <strong>Pending Approval</strong>
                    </Alert>      
                    <Col  xl={3}>
                            <Timeline stage={st}/>
                                {/*<Card>
                                    <CardBody>
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">IPA Actions</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12}>
                                        <div className="d-grid">
                  
                                            <ButtonDropdown
                                                isOpen={btnprimary1}
                                                toggle={() => setBtnprimary1(!btnprimary1)}
                                                >
                                                <DropdownToggle tag="button" className="btn btn-primary">
                                                    + Add Deliverables <i className="mdi mdi-chevron-down" />
                                                </DropdownToggle>
                                                
                                                <DropdownMenu>
                                                    <DropdownItem >Add Technical Job Deliverables</DropdownItem>
                                                    <DropdownItem >Add Competence Targets</DropdownItem>
                                                    <DropdownItem >Add Staff with People Management roles</DropdownItem>
                                                    <DropdownItem >Add Short Term Development Needs</DropdownItem>
                                                    
                                                </DropdownMenu>
                                            
                                            </ButtonDropdown>
                                            </div>
                                        </Col>
                                    </Row>
                                    </CardBody>
                                </Card>*/}

                        </Col>
                        <Col xl={9}>
                        <Card>
                            <CardBody>
                            <Row>
                                <Col sm={12}>
                                    <h5 className="text-primary">Details</h5>
                                        <hr/>
                                </Col>
                            </Row>
                       
                                    <Row>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Employee No</label>
                                            <input type="text" className="form-control" disabled={true}  defaultValue = {empNo} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Employee Name</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={empName} />
                                        </div>
                                    </Col>
                                   
                              
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Title</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={empTitle} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorNo} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor Name</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorName} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor Title</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorTitle}  />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                            <Row>
                                <Col sm={12}>
                                    <h5 className="text-primary">IPA Details</h5>
                                        <hr/>
                                </Col>
                            </Row>
                                <Row>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>No</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaNo}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Department Code</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={departmentCode}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Convert to PA</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaConvert}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Performance Type</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={performanceType}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Performance Year</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaPerformanceYear}  />
                                        </div>
                                </Col>
                                {/*<Col md={4}>
                                        <div className="mb-3">
                                            <label>Stage</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={stage}  />
                                        </div>
                                </Col>*/}
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaStatus}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Posting Date</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaDate}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label>Type of Performance Appraisal</label>
                                        <select className="form-select" value={type} onChange={(e)=>setType(e.target.value)}>
                                                    <option value="">Select</option>
                                                    {apType.map((a,k)=>(
                                                        <option value={a} key={k}>{a}</option>
                                                    ))}
                                                </select>
                                        
                                        </div>
                                    </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label>Start Date</label>
                                        <Flatpickr
                                            className="form-control"
                                            options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d",
                                                disabled: true
                                            }}
                                            value={new Date(startDate)}
                                            onChange={(date)=>setStartDate(date)}
                                        />
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>End Date</label>
                                        <Flatpickr
                                            className="form-control"
                                            options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d",
                                                disabled: true
                                            }}
                                            value={new Date(endDate)}
                                            onChange={(date)=>setEndDate(date)}
                                        />
                                        </div>
                                    </Col>
                                    
                                    </Row>
                                
                             
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Technical Job Deliverables ({ipaLines1.length})</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {(ipaLines1.map((i,k)=>(
                                        <Row key={k}>
                                            <Col lg={10}>
                                                <div className="p-4">
                                                    <h5 className="text-primary">Line {k+1}</h5>

                                                    <div className="text-muted">
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Key Result Area: </strong><br/>{i.KeyResultArea}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Statement of target to be achieved: </strong><br/>{i.StatementofTargettobeachieved} 
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Key Performance Indicator: </strong><br/>{i.KeyPerformanceIndicator}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Resources Required: </strong><br/>{i.ResourcesandSupportRequiredforachievementsettargetsandgoals}
                                                    </p>
                                                    
                                                    </div>
                                                </div>
                                            </Col>
                                           
                                        </Row>
                                    )))}
                          
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Competence Targets ({ipaLines2.length})</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {(ipaLines2.map((i,k)=>(
                                        <Row key={k}>
                                            <Col lg={10}>
                                                <div className="p-4">
                                                    <h5 className="text-primary">Line {k+1}</h5>

                                                    <div className="text-muted">
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Competence Code: </strong><br/>{i.CompetenceCode} 
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Description: </strong><br/>{i.competenciesdescription} 
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Critical Attributes Targeted: </strong><br/>{i.CriticalAttributestargetedundereachcompetence}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Key Performance Indicator: </strong><br/>{i.KeyPerformanceIndicator}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Resources and support required: </strong><br/>{i.ResourcesandSupportRequiredforachievementsettargetsandgoals}
                                                    </p>
                                                
                                                    </div>
                                                </div>
                                            </Col>
                                            
                                        </Row>
                                    )))}
                                   {/*} <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Staff with People Management roles ({ipaLines3.length})</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {(ipaLines3.map((i,k)=>(
                                        <Row key={k}>
                                            <Col lg={10}>
                                                <div className="p-4">
                                                    <h5 className="text-primary">Line {k+1}</h5>

                                                    <div className="text-muted">
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>What was done to Support those reporting to You: </strong><br/>{i.Supportthosereportingtoyoutoimplementthisyearsperformanceandlearninganddevelopmentobjectives} 
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Planned results: </strong><br/>{i.PlannedResultsWhatwastheindicatorofCoachingresults}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Actual Coaching results: </strong><br/>{i.ActualCoachingResultsWhatwasachievedandimpact}
                                                    </p>
                                                    </div>
                                                </div>
                                            </Col>
                                            
                                        </Row>
                                    )))} */}
                            
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Short Term Development Needs ({ipaLines4.length})</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {(ipaLines4.map((i,k)=>(
                                        <Row key={k}>
                                            <Col lg={10}>
                                                <div className="p-4">
                                                    <h5 className="text-primary">Line {k+1}</h5>

                                                    <div className="text-muted">
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Development goal: </strong><br/>{i.DevelopmentGoalsIdentifiedlearningdevelopmentareas} 
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Learning development method: </strong><br/>{i.LearningDevelopmentMethodsHowwilltheLearningandDevelopmentbeachieved}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Application: </strong><br/>{i.ApplicationWhatistheexpectedchangeinperformanceafteracquiringtheidentifiedskills}
                                                    </p>
                                                    </div>
                                                </div>
                                            </Col>
                                            
                                        </Row>
                                    )))}
                                    </CardBody>
                                    </Card>
                                    </Col>
                            <Col md={3}></Col>
                            <Col md={9}>
                                <div>
                               
                                {(ipaStatus == 'Pending Approval') && (
                                    <>
                                        <Row>
                                        <Col md={12}>
                                                    <div className="form-floating mb-3">
                                                        <select  className="form-select lAction" onChange={handleActionChange}>
                                                            
                                                            <option value="APPROVE">APPROVE IPA</option>
                                                            <option value="REJECT">REJECT IPA</option>
                                    
                                                        </select>
                                                        <label htmlFor="floatingSelectGrid"> Select Action</label>
                                                    </div>
                                                </Col>
                                        </Row>
                                        {showRejectBtn && (
                                                <Row>
                                                <Col md={12}>
                                                    <div className="form-floating mb-3">
                                                        <input  type="text" className="form-control" onChange={(e)=>setComment(e.target.value)}  />
                                                        <label htmlFor="floatingSelectGrid"> Rejection Comment</label>
                                                    </div>
                                                </Col>
                                                </Row>
                                            )}
                                        <Row className=' justify-content-center align-items-center'>
                                                {showRejectBtn && (
                                                <Col md={6} className="reject">
                                                    <div className="d-grid gap-2">
                                                        <Button color="danger" type="button" className="btn btnRejectRequest" onClick={handleRejectIpa}>
                                                            Reject
                                                        </Button>
                                                    </div>
                                                </Col>
                                                )}
                                                {showApproveBtn && (
                                                <Col md={6} className="approve">
                                                    <div className="d-grid gap-2">
                                                        <Button color="success" type="button" className="btn btnApproveRequest" onClick={handleApproveIpa}>
                                                            Approve 
                                                        </Button>
                                                    </div>
                                                </Col>
                                                )}
                                            </Row>
                                    </>)}

                          
                                    </div>
                                    <br/>
      
                                   
            
                </Col>
                </Row>

                </div>


                
                   

            </Container>
        </div>
        </LoadingOverlay>
        );
    }


export default ApproveIPA;